<template lang="pug">
  .tag
    span.tag-content
      slot
      | {{ content[labelName] || content }}
    button.close(type="button",aria-label="Delete Tag",@click="$emit('removeTag', content)")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  name: 'Tag',
  props: {
    content: {
      type: [String, Object],
      default: '',
    },
    labelName: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
.tag {
  background-color: #f2f2f2;
  border: 1px solid #cccccc;
  border-radius: 0.3rem;
  padding: 0.5rem;
  margin-right: 0.4rem;
}
button.close {
  span {
    font-size: 1.3rem !important;
    margin-left: 0.8rem;
  }
}
</style>
